import React from 'react';
import { Button, Col, Row, Spinner } from 'react-bootstrap';
import * as ROUTES from '../../constants/routes';
import useApi from '../../hooks/use-api';
import ProgressNotes from './ProgressNotes';
import ProgressOverview from '../../components/Tables/EmployeeDetails/Progress/ProgressOverview';

function Progress({ studentId, dationInstanceId, educationId }) {
	const [showNotes, setShowNotes] = React.useState(false);
	const [{ data, isLoading }] = useApi.get(ROUTES.getProgressCardForStudent(studentId), {
		dationInstanceId,
		educationId,
	});

	if (isLoading) {
		return (
			<div className="d-flex justify-content-center">
				<Spinner animation="border" variant="primary" />
			</div>
		);
	}

	if (!data?.template) {
		return <p>Er zijn nog geen vorderingen voor deze opleiding.</p>;
	}
	return (
		<Row>
			<Col xs={12} className="text-end">
				<Button
					disabled={data?.notes?.length < 1}
					onClick={() => setShowNotes(true)}
					variant="outline-secondary"
					className="mb-2">
					Notities
				</Button>
				<ProgressOverview progressCardData={data} />
			</Col>
			<ProgressNotes
				show={showNotes}
				onHide={() => setShowNotes(false)}
				notes={data?.notes || []}
			/>
		</Row>
	);
}

export default Progress;
